import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { SERVICES_ON_FACILITY, SERVICES_ON_FACILITY_SUCCESS, SERVICES_ON_FACILITY_ERROR } from './../../actionType';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';
import { baseUrl, customHeaders, uaeProjectsBaseURL } from '../../../../Containers/Config';

function* getServiceOnFacility({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/services?pageIndex=0&pageSize=${100}`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: SERVICES_ON_FACILITY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SERVICES_ON_FACILITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SERVICES_ON_FACILITY_ERROR, payload: error });
  }
}

export function* watchGetServiceOnFacility() {
  yield takeEvery(SERVICES_ON_FACILITY, getServiceOnFacility);
}

function* getServiceOnFacilitySaga() {
  yield all([fork(watchGetServiceOnFacility)]);
}

export default getServiceOnFacilitySaga;
